<template>
  <base-dialog
    class="queue-upload"
    v-model="visible"
    @ok="doUpload"
    :ok-text="okText"
    :ok-loading="okLoading"
    :ok-disabled="okDisabled"
    :show-cancel="false"
  >
    <div style="color: red; margin-bottom: 10px">温馨提示：文件需解密</div>
    <form class="form-hide" ref="form">
      <input ref="file" type="file" @change="change" multiple />
    </form>
    <div v-show="rows.length > 0" class="file-table-wrap">
      <el-button type="danger" @click="clearSelectFile">清空文件</el-button>
      <base-table
        ref="table"
        :columns="columns"
        :show-pagination="false"
        :init-search="false"
      ></base-table>
    </div>
    <el-button v-show="rows.length == 0" type="primary" @click="selectFile"
      >选择文件</el-button
    >
  </base-dialog>
</template>
<script>
export default {
  name: 'queue-upload',
  props: {
    checkFile: {
      type: Function,
      require: true,
    },
    calckey: {
      type: Function,
      require: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
    action: String,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      okText: '上传',
      okLoading: false,
      okDisabled: true,
      columns: [
        { bind: { label: '文件', prop: 'name' } },
        {
          bind: { label: '状态', prop: 'state' },
          default: {
            component: 'upload-state',
          },
        },
        { bind: { label: '消息', prop: 'msg' } },
      ],
      rows: [],
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('change', newValue)
      },
    },
    table() {
      return this.$refs.table
    },
  },
  methods: {
    reset() {
      this.okLoading = false
      this.okDisabled = true
      this.rows = []
      this.clearFile()
    },
    clearFile() {
      this.$refs.form.reset()
    },
    change(e) {
      if (e.target.files.length > 0) {
        var rows = []
        for (var file of e.target.files) {
          rows.push({
            file,
            name: file.name,
            size: file.size,
            key: '',
            state: 0,
            md5: '',
            msg: '',
          })
        }
        this.rows = rows
        this.okDisabled = false
      }
    },
    selectFile(e) {
      var evt = document.createEvent('MouseEvent')
      evt.initEvent('click', true, true)
      this.$refs.file.dispatchEvent(evt)
    },
    clearSelectFile() {
      if (confirm('确定清空文件？')) {
        this.reset()
      }
    },
    doUpload() {
      if (this.rows.length <= 0) {
        this.$message('文件为空')
        return
      }
      this.okLoading = true
      this.nextUpload()
    },
    nextRow() {
      for (var row of this.rows) {
        if (row.state == 0) {
          return row
        }
      }
      return null
    },
    nextUpload() {
      var row = this.nextRow()
      if (row) {
        if (typeof this.checkFile == 'function' && !this.checkFile(row)) {
          this.nextCallback(row, false)
          return
        }
        row.state = 1 //上传中
        row.key = this.calckey(row.file)
        this.$uploadOSS(this.action, row.file, row.key)
          .then((etag) => {
            row.md5 = etag
            this.$emit('upload-item', row, this.nextCallback)
          })
          .catch((err) => {
            console.error(err)
            row.msg = '上传文件到OSS发生失败=>' + err.toString()
            this.nextCallback(row, false)
          })
      } else {
        this.okLoading = false
        this.okDisabled = true

        var completeMsg = '上传任务已完成'
        var failCount = this.getFailCount()
        if (failCount) {
          completeMsg += '，其中上传失败共' + failCount + '项'
        }
        alert(completeMsg)
        //this.visible = false
        this.$emit('success')
      }
    },
    getFailCount() {
      var count = 0
      for (var row of this.rows) {
        if (row.state == 3) {
          count++
        }
      }
      return count
    },
    nextCallback(row, flag) {
      if (flag) {
        row.state = 2 //上传成功
        this.nextUpload()
      } else {
        row.state = 3 //上传失败
        this.nextUpload() //即使上传失败也不中断上传队列
      }
    },
  },
  watch: {
    rows(newVal) {
      this.$nextTick(() => {
        this.table.setTableData({
          rows: newVal,
          total: newVal.length,
        })
      }, 500)
    },
    visible(newVal) {
      if (!newVal) {
        this.reset()
      }
    },
  },
}
</script>
<style lang="less">
.queue-upload {
  .form-hide {
    display: none;
  }
  .file-table-wrap {
    height: 500px;
  }
}
</style>